import {css} from 'lit';

export default css`
.icon-bell {
  width: 3.5rem;
  height: 3.5rem;
  float: left;
  margin-right: 1.6rem;
  background-position: 40%;
  background-size: auto 75%;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-image: var(--icon-bell);
  background-color: var(--notisettings-icon-bell-bg);
}
`;
